import React from "react";
import {
  Box,
  Grid,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Divider,
} from "@mui/material";

const DAILY_SYMPTOM_KEYS = [
  "constipation",
  "bloating",
  "diarrhoea",
  "abdominalPain",
  "mixed",
  "flatulence",
];

const checkboxSx = {
  color: "#163666",
  "&.Mui-checked": { color: "#163666" },
  p: 0.75,
};

export const AdditionalInfoSection = ({
  formData,
  handleNestedChange,
  setFormData,
  isEditable,
  validationErrors,
  t,
}) => (
  <>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
      <Box sx={{ width: 3, height: 22, backgroundColor: "#163666", borderRadius: 2, flexShrink: 0 }} />
      <Typography variant="h6" sx={{ fontWeight: 700, color: "#1a1a2e" }}>
        {t.additionalInformation}
      </Typography>
    </Box>

    <Grid container spacing={3} sx={{ mb: 4 }}>
      {/* Initial / Follow-up */}
      <Grid size={{ xs: 12, sm: 6 }}>
        <Box
          sx={{
            backgroundColor: "#f8fafc",
            borderRadius: 2,
            border: validationErrors.initialOrFollowUp
              ? "2px solid #ef4444"
              : "1px solid #dfdfdf",
            p: 2.5,
            height: "100%",
          }}
        >
          <Typography variant="body2" sx={{ mb: 2, fontWeight: 600, color: "#374151", fontSize: "0.825rem" }}>
            {t.initialOrFollowUp} <span style={{ color: "#ef4444" }}>*</span>
          </Typography>
          <FormGroup>
            <Grid container>
              <Grid size={{ xs: 6 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={formData.initialFindings}
                      onChange={() =>
                        setFormData((prev) => ({
                          ...prev,
                          initialFindings: true,
                          followUpTest: false,
                        }))
                      }
                      disabled={!isEditable}
                      sx={checkboxSx}
                    />
                  }
                  label={
                    <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                      {t.initialFindings}
                    </Typography>
                  }
                />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={formData.followUpTest}
                      onChange={() =>
                        setFormData((prev) => ({
                          ...prev,
                          followUpTest: true,
                          initialFindings: false,
                        }))
                      }
                      disabled={!isEditable}
                      sx={checkboxSx}
                    />
                  }
                  label={
                    <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                      {t.followUpTest}
                    </Typography>
                  }
                />
              </Grid>
            </Grid>
          </FormGroup>
        </Box>
      </Grid>

      {/* Daily Symptoms */}
      <Grid size={{ xs: 12, sm: 6 }}>
        <Box
          sx={{
            backgroundColor: "#f8fafc",
            borderRadius: 2,
            border: "1px solid #dfdfdf",
            p: 2.5,
            height: "100%",
          }}
        >
          <Typography variant="body2" sx={{ mb: 2, fontWeight: 600, color: "#374151", fontSize: "0.825rem" }}>
            {t.dailySymptoms}
          </Typography>
          <FormGroup>
            <Grid container>
              {DAILY_SYMPTOM_KEYS.map((key) => (
                <Grid size={{ xs: 6 }} key={key}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={formData.dailySymptoms[key]}
                        onChange={(e) =>
                          handleNestedChange("dailySymptoms", key, e.target.checked)
                        }
                        disabled={!isEditable}
                        sx={checkboxSx}
                      />
                    }
                    label={
                      <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                        {t[key]}
                      </Typography>
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </FormGroup>
        </Box>
      </Grid>
    </Grid>

    <Divider sx={{ mb: 4, borderColor: "#dfdfdf" }} />
  </>
);
